import { render } from "./PasteView.vue?vue&type=template&id=26230772&scoped=true"
import script from "./PasteView.vue?vue&type=script&lang=js"
export * from "./PasteView.vue?vue&type=script&lang=js"

import "./PasteView.vue?vue&type=style&index=0&id=26230772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26230772"]])

export default __exports__